import { Button } from '@bambi/component-library/src/components/Button/Button';
import { CoreFormFieldText } from '@bambi/component-library/src/components/forms/fields/CoreFormFieldText';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';
import {
  routeTemplateActions,
  routeTemplateSelectors,
} from 'src/features/trip/routeTemplates/routeTemplates.slice';

export function RouteTemplatesFilters() {
  const dispatch = useAppDispatch();
  const { inputValue, handleInputChange } = useDebouncedSearch(
    routeTemplateActions.setFilterSearch
  );

  const hasFilters = useAppSelector(routeTemplateSelectors.hasFilters);

  return (
    <div className="flex flex-row gap-2">
      <div className="max-w-sm">
        <CoreFormFieldText
          inputProps={{
            placeholder: 'Search by name',
            value: inputValue,
            onChange: (e) => {
              handleInputChange(e.target.value);
            },
          }}
        />
      </div>
      {hasFilters && (
        <Button
          variant="anchor"
          onClick={() => {
            handleInputChange('');
            dispatch(routeTemplateActions.clearFilters());
          }}
        >
          clear filters
        </Button>
      )}
    </div>
  );
}
